'use strict';

angular.module('chatEngine.apiKey', [
    'ui.bootstrap',
    'chatEngine.dialog'
])

.controller('ApiKeyCtrl', ['$rootScope', '$scope', '$http', '$location', '$modal', '$window', 'Dialog', 'LoadingDialog',
    function($rootScope, $scope, $http, $location, $modal, $window, Dialog, LoadingDialog) {
    $scope.loadingApiKey = false;
    $scope.loadingApiKeyError = false;
    $scope.creatingApiKey = false;

    // Model
    $scope.apiKey = null;

    // Methods
    $scope.loadApiKey = function() {
        $scope.loadingApiKey = true;

        $http.get('/api/v1/api_key')
            .error(apiKeyLoaded)
            .success(apiKeyLoaded);
    };

    function apiKeyLoaded(data, status) {
        $scope.loadingApiKey = false;

        if (status === 200) {
            $scope.apiKey = data;
        } else {
            $scope.loadingApiKeyError = true;
        }
    }

    $scope.regenerateApiKey = function() {
        function doCreate() {
            var dialog = LoadingDialog.show('Regenerating your API key, please wait...');

            $scope.creatingApiKey = true;
            $http.post('/api/v1/api_key')
                .error(regenerateApiKeyError)
                .success(apiKeyRegenerated)
                .finally(function() {
                    if(dialog) {
                        LoadingDialog.hide(dialog);
                    }
                });
        }

        if ($scope.apiKey) {
            Dialog.confirm('Confirm regeneration','Are you sure you want to regenerate your API key? ' +
                'API calls with the current key will fail afterwards.').result.then(doCreate);
        } else {
            doCreate();
        }
    };

    function regenerateApiKeyError() {
        $scope.creatingApiKey = false;
        Dialog.alert('Error', 'Error trying to create your API key, please try again later.');
    }

    function apiKeyRegenerated(data) {
        $scope.creatingApiKey = false;
        $scope.apiKey = data;
    }

    // Let's do it!
    $scope.loadApiKey();
}]);
